/* Cart Quantity Counter */

function cartQuant() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      const totalItems = cartData.item_count;
      document.querySelectorAll('.cart_quant').forEach((el) => {
        el.textContent = totalItems;
      });
    });
}
cartQuant();

document.addEventListener('DOMContentLoaded', function () {
  var checkbox = document.querySelector('.menu_input');
  var header = document.querySelector('.header');
  var tabs = document.querySelector('.tabs');
  var line_one = document.querySelector('.menu_line_one');
  var line_two = document.querySelector('.menu_line_two');
  var line_three = document.querySelector('.menu_line_three');
  var lastScrollTop = 0;

  function handleScroll() {
    var scrollTop = window.scrollY;
    if (scrollTop > lastScrollTop) {
      header.style.opacity = 0;
      header.style.pointerEvents = 'none';
    } else {
      header.style.opacity = 1;
      header.style.pointerEvents = 'auto';
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
  window.addEventListener('scroll', handleScroll);

  checkbox.addEventListener('change', function () {
    if (checkbox.checked) {
      tabs.classList.add('header_show');
      setTimeout(function () {
        tabs.style.opacity = 1;
      }, 150);
      line_two.style.opacity = 0;
      line_one.style.transform = 'rotate(45deg) translateY(4px)';
      line_three.style.transform = 'rotate(-45deg) translateY(-4px)';
    } else {
      tabs.style.opacity = 0;
      setTimeout(function () {
        tabs.classList.remove('header_show');
      }, 150);
      line_one.style.transform = 'rotate(0deg) translateY(0px)';
      line_three.style.transform = 'rotate(0deg) translateY(0px)';
      line_two.style.opacity = null;
    }

    handleScroll();
  });
});
